export default __webpack_public_path__ + "static/media/leftMasjit.10b2ba82.png";